var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "url(#paint0_linear_2271_4464)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_4464)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 16.6406C18.9772 16.6406 14.5 21.1178 14.5 26.6406C14.5 28.6221 15.077 30.4709 16.0725 32.0258C16.2038 32.2309 16.4305 32.3549 16.674 32.3549H32.326C32.5694 32.3549 32.7963 32.2309 32.9276 32.0258C33.923 30.4709 34.5 28.6221 34.5 26.6406C34.5 21.1178 30.0229 16.6406 24.5 16.6406ZM25.5377 23.0395V29.4957H23.4502V23.0395C23.4502 22.463 23.9175 21.9957 24.4939 21.9957C25.0704 21.9957 25.5377 22.463 25.5377 23.0395Z",
    fill: "url(#paint1_linear_2271_4464)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_4464",
    x1: 0,
    y1: 0,
    x2: 49,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA5A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_4464",
    x1: 24.5,
    y1: 16.6406,
    x2: 24.5,
    y2: 32.3549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_4464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14.5 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMeter);
export default __webpack_public_path__ + "static/media/orange-meter.9cd4415964411b7460233e8b5674d2e2.svg";
export { ForwardRef as ReactComponent };